<template>
    <div class="inline-flex rounded-md shadow-sm">
        <a v-if="primary_item && primary_item.type === 'link'" :href="primary_item.href" :class="['relative inline-flex items-center bg-white px-3 py-2 text-sm font-medium text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10 h-[40px]', Array.isArray(items) && items.length ? 'rounded-l-md' : 'rounded-md']">{{ primary_item.label }}</a>
        <button v-else-if="primary_item && primary_item.type === 'button'" type="button" v-on:click="() => primary_item.action()" :class="['relative inline-flex items-center bg-white px-3 py-2 text-sm font-medium text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10 h-[40px]', Array.isArray(items) && items.length ? 'rounded-l-md' : 'rounded-md']">{{ primary_item.label }}</button>
        <Menu v-if="Array.isArray(items) && items.length" as="div" class="relative -ml-px block">
            <MenuButton class="relative inline-flex items-center rounded-r-md bg-white px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10 h-[40px]">
                <span class="sr-only">Open options</span>
                <ChevronRightIcon class="h-4 w-4 rotate-90" aria-hidden="true" />
            </MenuButton>
            <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform scale-100 w-full" leave-active-class="transition ease-in duration-75" leave-from-class="transform scale-100" leave-to-class="transform opacity-0 scale-95">
                <MenuItems class="absolute right-0 z-10 -mr-1 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg outline outline-1 outline-black/5">
                    <div class="py-1 w-full">
                        <MenuItem v-for="item in items" :key="item.label" v-slot="{ active }">
                            <a v-if="item.type === 'link'" :href="item.href" :class="[active ? 'bg-gray-100 text-gray-900 outline-none' : 'text-gray-700', 'block px-4 py-2 text-sm w-full text-left cursor-pointer']" :target="item.target || ''">{{ item.label }}</a>
                            <button v-else-if="item.type === 'button'" :class="[active ? 'bg-gray-100 text-gray-900 outline-none' : 'text-gray-700', 'block px-4 py-2 text-sm w-full text-left']" v-on:click="() => item.action()">{{ item.label }}</button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </transition>
        </Menu>
    </div>
</template>

<script>
import { computed } from 'vue'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import ChevronRightIcon from "@ico/ChevronRightIcon.vue"

export default {
    components: {
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        ChevronRightIcon
    },
    props: ['items'],
    setup (props) {
        const primary_item = computed(() => {
            return Array.isArray(props.items) && props.items.length
                ? props.items[0]
                : null
        })

        return {
            primary_item
        }
    }
}
</script>